<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11 7V11L12.5 12.5"
      :stroke="iconStroke"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.5454 15.4534C20.1818 16.337 21 16.7789 21 17.5C21 18.2211 20.1818 18.663 18.5454 19.5466L17.4311 20.1484C16.1744 20.827 15.5461 21.1663 15.2439 20.9196C14.504 20.3154 15.6567 18.7561 15.9403 18.2037C16.2277 17.644 16.2225 17.3459 15.9403 16.7963C15.6567 16.2439 14.504 14.6846 15.2439 14.0804C15.5461 13.8337 16.1744 14.173 17.4311 14.8516L18.5454 15.4534Z"
      :stroke="iconStroke"
      stroke-width="1.5"
    />
    <path
      d="M12.0261 20.948C11.6888 20.9824 11.3464 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11C21 11.6849 20.9311 12.3538 20.8 13"
      :stroke="iconStroke"
      stroke-width="1.5"
      stroke-linecap="round"
    />
  </svg>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '22',
    },
    width: {
      type: String,
      default: '22',
    },
    color: {
      type: String,
      default: 'primary-purple-600',
    },
  },
  computed: {
    /**
     * Icon Style
     * @param {void}
     * @returns {string} - Color
     * @description Assigns the specific color to the icon
     */
    iconStroke() {
      return `var(--${this.color})`
    },
  },
}
</script>
